export enum Consents {
  SERVICES = "service",
  MARKETING = "marketing",
  PROFILING = "profiling",
  THIRD_PARTIES = "third_parties",
  WHATSAPP = "messaging",
  TERMS_AND_CONDITIONS = "terms_and_conditions"
}
